import { ContentRight } from '@uno/common-shared';
import { withAuthSync } from 'components/common/withAuthSync/withAuthSync';
import Edit from './Edit';
export default withAuthSync(Edit, ContentRight.EDIT_CONTENT);